/** 전역 푸터 - 모든 페이지 하단 카피라이트 */
export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="app-footer">
      <div className="app-footer__inner">
        <span>
          © {year} 
        </span>
        <span>
          <a
            href="https://www.ggcontent.com"
            target="_blank"
            rel="noopener noreferrer"
            className="underline hover:text-ggc-cta-blue"
          >
            GC Social Media Marketing
          </a>,
        </span>
        <span>
          Inc. All Rights Reserved.
        </span>
      </div>
    </footer>
  );
}
